import React from 'react';
import {Flex,Grid} from '@chakra-ui/react';

const ViewSetting = (props:any) => {
  return (
    <Grid gap="20px" templateColumns="1fr">
        {props.children}
    </Grid>
  )
}

export default ViewSetting